import $axios from '@/api/apiPublic';

const getFaq = async tag => {
  const response = await $axios.get(`faq/?tag=${tag}`);
  return response;
};

export default {
  getFaq,
};
